module.exports = __webpack_public_path__ + "static/media/Folder-user.ba5b4ceb.png";